import React, { useEffect, useState } from "react";
import { getCompleteData, getItems, getYears } from "../../../actions/HomeAction";
import Axios from "../../../axios/axios";

function RentalAdvancedSearch({ filters, setFilters, currentCategoryId }) {

  const [regions, setRegions] = useState([]);
  const [years, setYears] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    getItems(setRegions);
    setYears(getYears());
    getCompleteData(setBrands, () => {}, setModels);
  }, []);

  // Load subcategories when category changes
  useEffect(() => {
    if (!currentCategoryId) {
      setSubcategories([]);
      setFilters(prev => ({ ...prev, subcategoryId: "" }));
      return;
    }

    const fetchCategory = async () => {
      try {
        const res = await Axios.get(`/category/${currentCategoryId}`);
        setSubcategories(res.data.subcategories || []);
      } catch (err) {
        setSubcategories([]);
      }
    };

    fetchCategory();
  }, [currentCategoryId]);

  const handleChange = (e) => {
    setFilters(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const clearFilters = () => {
    setFilters(prev => ({
      year: "",
      regionId: "",
      brandId: "",
      modelId: "",
      condition: "",
      availabilityStatus: "",
      features: "",
      certifications: "",
      subcategoryId: "",
      categoryId: prev.categoryId // keep selected category
    }));
  };

  return (
    <div className="container py-4">
      <h4 className="mb-3">Rental Advanced Search</h4>

      <button className="btn btn-sm btn-secondary mb-3" onClick={clearFilters}>
        Clear Filters
      </button>

      {subcategories.length > 0 && (
        <div className="advanced-filter-wrapper mb-2">
          <select
            name="subcategoryId"
            value={filters.subcategoryId || ""}
            className="form-control"
            onChange={handleChange}
          >
            <option value="">Select Subcategory</option>
            {subcategories.map(sc => (
              <option key={sc._id} value={sc._id}>{sc.name}</option>
            ))}
          </select>
        </div>
      )}

      {/* Year */}
      <div className="advanced-filter-wrapper mb-2">
        <select name="year" value={filters.year || ""} className="form-control" onChange={handleChange}>
          <option value="">Select Year</option>
          {years.map(year => <option key={year} value={year}>{year}</option>)}
        </select>
      </div>

      {/* Region */}
      <div className="advanced-filter-wrapper mb-2">
        <select name="regionId" value={filters.regionId || ""} className="form-control" onChange={handleChange}>
          <option value="">Select Region</option>
          {regions.map(r => <option key={r._id} value={r._id}>{r.name}</option>)}
        </select>
      </div>

      {/* Condition */}
      <div className="advanced-filter-wrapper mb-2">
        <select name="condition" value={filters.condition || ""} className="form-control" onChange={handleChange}>
          <option value="">Select Condition</option>
          <option value="New">New</option>
          <option value="Good">Good</option>
          <option value="Average">Average</option>
          <option value="Needs Repair">Needs Repair</option>
        </select>
      </div>

      {/* Availability */}
      <div className="advanced-filter-wrapper mb-2">
        <select
          name="availabilityStatus"
          value={filters.availabilityStatus || ""}
          className="form-control"
          onChange={handleChange}
        >
          <option value="">Select Availability</option>
          <option value="Available">Available</option>
          <option value="Rented">Rented</option>
          <option value="Under Maintenance">Under Maintenance</option>
        </select>
      </div>

      {/* Features */}
      <div className="advanced-filter-wrapper mb-2">
        <input
          type="text"
          name="features"
          value={filters.features || ""}
          placeholder="Features (comma separated)"
          className="form-control"
          onChange={handleChange}
        />
      </div>

      {/* Certifications */}
      <div className="advanced-filter-wrapper mb-2">
        <input
          type="text"
          name="certifications"
          value={filters.certifications || ""}
          placeholder="Certifications (comma separated)"
          className="form-control"
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default RentalAdvancedSearch;
